import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

interface TabProps {
  active: boolean;
}

const TabContainer = styled.div`
  display: flex;
  background: #f4f5f7;
  user-select: none;
`;
const Tab = styled.span`
  cursor: pointer;
  padding: 4px 3px;
  color: #5c5f63;
  font-family: acumin-pro;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 17px;
  background: ${(props: TabProps) => (props.active ? '#FFF' : '#E7EAEF')};
  border-right: 4px solid #f4f5f7;
  white-space: nowrap;
  @media screen and ${(props) => props.theme.breakpoints.lg} {
    font-size: 14px;
    padding: 8px 13px;
  }
`;

const tabKeys: Record<number, string> = {
  0: 'role',
  1: 'user-details',
  2: 'knowledge',
  3: 'work-experience',
  4: 'education',
  5: 'additional-information',
};

const FormTabs = ({
  phases,
  currentTab,
  onTabChange,
}: {
  phases: number[];
  currentTab: number;
  onTabChange: Function;
}) => {
  const { t } = useTranslation();
  return (
    <TabContainer>
      {phases.map((phase, index) => (
        <Tab
          key={phase}
          active={currentTab === index}
          onClick={() => onTabChange(index)}
        >
          {t(tabKeys[phase])}
        </Tab>
      ))}
    </TabContainer>
  );
};

export default FormTabs;
